export * from './add-person-sub-menu.component';
export * from './add-person-sub-menu.config';
